<!-- ============================================================== -->
<!-- sidebar -->
<!-- ============================================================== -->
<div
  class="user-profile"
  style="
    background: url(assets/images/background/user-info-orange.svg) no-repeat;
    background-size: cover;
  "
>
  <!-- User profile image -->
  <div class="profile-img" (click)="closeSideNav()">
    <img
      [src]="
        userService?.UserProfile?.avatar ||
        'assets/images/blank-profile-picture.jpg'
      "
      alt="user"
    />
  </div>
  <!-- User profile text-->
  <!-- ============================================================== -->
  <!-- Profile - style you can find in header.scss -->
  <!-- ============================================================== -->
  <div class="profile-text">
    <a [matMenuTriggerFor]="sdprofile" class="">
      {{ userService?.UserProfile?.name }}
      <i class="ti-angle-down font-12 m-l-5"></i>
    </a>
  </div>
  <mat-menu #sdprofile="matMenu" class="mymegamenu">
    <button mat-menu-item routerLink="/others/my-profile" (click)="closeSideNav()">
      <mat-icon>account_box</mat-icon> Profile
    </button>

    <button mat-menu-item (click)="authService.logout()">
      <img src="assets/images/icon/px-logout.svg" style="vertical-align:middle;" class="sidebar-icon"/>
      <span class="subblack">Log Out</span>
    </button>
  </mat-menu>
</div>

<mat-nav-list>
  <mat-list-item
    routerLink="/project-setting/project-list"
    routerLinkActive="active-page"
    (click)="closeSideNav()"
  >
    <a class="">
      <img src="assets/images/icon/home.svg" class="sidebar-icon"/>
      <span class="subblack">Home</span>
    </a>
  </mat-list-item>
  <!-- <mat-list-item
    routerLink="/developer-user/user-list"
    routerLinkActive="active-page"
    (click)="closeSideNav()"
  >
    <a class="">
      <mat-icon class="lead-icon-color">local_library</mat-icon>
      <span>User</span>
    </a>
  </mat-list-item> -->
  <mat-list-item
    routerLink="/developer-user/access-security"
    routerLinkActive="active-page"
    (click)="closeSideNav()"
  >
    <a class="">
      <img src="assets/images/icon/access-security.svg" class="sidebar-icon"/>
      <span class="subblack">Access Security</span>
    </a>
  </mat-list-item>

  <!-- <mat-list-item
    routerLink="/team-setting/team-list"
    routerLinkActive="active-page"
    (click)="closeSideNav()"
  >
    <a class="">
      <mat-icon class="lead-icon-color">sports_kabaddi</mat-icon>
      <span>Team</span>
    </a>
  </mat-list-item> -->
  <mat-list-item
    routerLink="/company-setting/company-list"
    routerLinkActive="active-page"
    (click)="closeSideNav()"
  >
    <a class="">
      <img src="assets/images/icon/px-company.svg" class="sidebar-icon"/>
      <span class="subblack">Company</span>
    </a>
  </mat-list-item>

  <mat-list-item
    routerLink="/event/campaign-list"
    routerLinkActive="active-page"
    (click)="closeSideNav()"
  >
    <a class="">
      <img src="assets/images/icon/px-campaign.svg" class="sidebar-icon"/>
      <span class="subblack">Campaign</span>
    </a>
  </mat-list-item>

  <!-- <mat-list-item
    routerLinkActive="active-page"
    routerLink="/discount/discount-list"
    (click)="closeSideNav()"
  >
    <a class="">
      <img src="assets/images/icon/px-discount.svg" class="sidebar-icon"/>
      <span class="subblack">Discount</span>
    </a>
  </mat-list-item> -->
  <!-- <mat-list-item
    routerLinkActive="active-page"
    routerLink="/banker-setting/banker-list"
    (click)="closeSideNav()"
  >
    <a class="">
      <img src="assets/images/icon/px-end-financier.svg" class="sidebar-icon"/>
      <span class="subblack">End Financier</span>
    </a>
  </mat-list-item>

  <mat-list-item
    routerLinkActive="active-page"
    routerLink="/solicitor-setting/solicitor-list"
    (click)="closeSideNav()"
  >
    <a class="">
      <img src="assets/images/icon/px-solicitor.svg" class="sidebar-icon"/>
      <span class="subblack">Solicitor</span>
    </a>
  </mat-list-item> -->

  <mat-list-item
    routerLinkActive="active-page"
    routerLink="/news-announcements/news-announcements-list"
    (click)="closeSideNav()"
  >
    <a class="">
      <img src="assets/images/icon/px-file.svg" class="sidebar-icon"/>
      <span class="subblack">Bulletin</span>
    </a>
  </mat-list-item>
  <!-- <mat-list-item routerLinkActive="active-page" routerLink="/payment/payment-list" (click)="closeSideNav()">
    <a class="">
      <mat-icon>payments</mat-icon>
      <span>Payment Gateway</span>
    </a>
  </mat-list-item> -->

  <mat-list-item
    routerLinkActive="active-page"
    routerLink="/online-users/online-users-list"
    (click)="closeSideNav()"
  >
    <a class="">
      <mat-icon style="font-size: 23px;">supervisor_account</mat-icon>
      <span class="subblack" style="padding-left: 2px;">Online Users</span>
    </a>
  </mat-list-item>

  <mat-list-item
    routerLinkActive="active-page"
    routerLink="/general-setting/setting-list"
    (click)="closeSideNav()"
  >
    <a class="">
      <img src="assets/images/icon/px-system_admin.svg" class="sidebar-icon"/>
      <span class="subblack">General Setting</span>
    </a>
  </mat-list-item>

  <!-- <mat-list-item
    routerLinkActive="active-page"
    routerLink="/general-setting/integration-api"
    (click)="closeSideNav()"
  >
    <a class="">
      <mat-icon>settings</mat-icon>
      <span class="subblack">Integration API</span>
    </a>
  </mat-list-item>

  <mat-list-item
    routerLinkActive="active-page"
    routerLink="/integration-api-setup/integration-api-list"
    (click)="closeSideNav()"
  >
    <a class="">
      <mat-icon>settings</mat-icon>
      <span class="subblack">Integration API Setup</span>
    </a>
  </mat-list-item> -->

  <!-- <mat-list-item (click)="closeSideNav()">
        <a class="">
            <mat-icon>library_books</mat-icon>
            <span>Agency Setting</span>
        </a>
    </mat-list-item> -->

  <mat-divider></mat-divider>

  <!-- <mat-list-item
    class="m-t-10"
    (click)="closeSideNav()"
    routerLinkActive="selected"
    routerLink="/setting/setting-list"
  >
    <a class="">
      <mat-icon>settings</mat-icon>
      <span>General Setting</span>
    </a>
  </mat-list-item> -->

  <mat-list-item (click)="authService.logout()">
    <a class="" (click)="closeSideNav()">
      <img src="assets/images/icon/px-logout.svg" class="sidebar-icon"/>
      <span class="subblack">Log Out</span>
    </a>
  </mat-list-item>
</mat-nav-list>
